import * as React from 'react';

const AxLoungeBanner = () => {
  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      controls={false}
      disablePictureInPicture
      controlsList="nodownload nofullscreen noplaybackrate"
      style={{
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    >
      <source
        src="https://file.fnf.co.kr/2026-04-14/l3XGXAJZIaI3xBsnd6uPCtFqOU0CF8nQxwEvczt7.mp4"
        type="video/mp4"
      />
      브라우저가 비디오 요소를 지원하지 않습니다.
    </video>
  );
};

export default AxLoungeBanner;
